"use client"

import { useAuthStore } from './auth-store'

/**
 * Auth state for components.
 *
 * `ClerkAuthBridge` is what actually populates the store; this is just the
 * read side. It used to own a Supabase session listener, which Clerk replaced.
 */
export function useAuthActions() {
  return useAuthStore()
}
